import { render, staticRenderFns } from "./ModalArea.vue?vue&type=template&id=3d9f24d6&scoped=true"
import script from "./ModalArea.vue?vue&type=script&lang=js"
export * from "./ModalArea.vue?vue&type=script&lang=js"
import style0 from "./ModalArea.vue?vue&type=style&index=0&id=3d9f24d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d9f24d6",
  null
  
)

export default component.exports